import {createSelector} from 'reselect';

import {getNavigation} from './store';
import {getIsMobile} from './system';
import getLayout, {SECTIONS} from './layout';

const getNavTabsDynamic = createSelector(
    [getLayout],
    (layout) => {
        let navItemsArray = [];

        // if navLabel is defined, include it in the nav bar
        layout.order.forEach(({name, navLabel}) => {
            if (navLabel) {
                navItemsArray.push({
                    id: name,
                    href: `#${name}`,
                    label: navLabel
                });
            }
        });

        return navItemsArray;
    }
);

const getNavActiveTabIndex = createSelector(
    [getNavigation],
    (navigation) => navigation.navActiveTabIndex
);

const getNavData = createSelector(
    [getNavTabsDynamic, getNavActiveTabIndex, getIsMobile],
    (navTabs, activeIndex, isMobile) => ({navTabs, activeIndex, isMobile})
);

const NAV_TABS = SECTIONS;

export default getNavData;
export {getNavData, NAV_TABS};
